<template>
    <div class="frmegyeniszamla_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>

        <div class="frmegyeniszamla_itemcont" v-show="InitDone">
            <div class="frmegyeniszamla_itemcont_col1">
                <div class="frmegyeniszamla_itemcont_col_inner">
                    <div style="width:100%; box-sizing:border-box; padding:0px; margin:0px; text-align:right;">
                        <a :href="egyenleg_infobutton_link" target="_blank" class="frmegyeniszamla_infobutton">
                            <i class="fal fa-info-circle"></i>
                        </a>
                    </div>
                    <span class="frmegyeniszamla_itemlabel">Felhasználható egyenleg</span>
                    <br><span class="frmegyeniszamla_itemdata" style="color: var(--colorMain4);">{{Egyenleg}}</span>
                    <div class="frmegyeniszamla_itemdata2" v-show="SimpleNincsKonyvelve!=''">
                        (könyvelésre vár <b>{{SimpleNincsKonyvelve}}</b> bankkártyás befizetés)
                    </div>
                    <br v-show="SimpleNincsKonyvelve==''">
                    <br>
                    <span class="frmegyeniszamla_itemlabel" style="font-size:16px;">melyből önsegélyezésre fordítható</span>
                    <br><span class="frmegyeniszamla_itemdata" style="font-size:18px;">{{Egyenleg180}}</span>
                </div>

            </div>
            <div class="frmegyeniszamla_itemcont_col2">
                <div class="frmegyeniszamla_itemcont_col_inner frmegyeniszamla_itemcont_col_inner_b2">
                    <div style="width:100%; box-sizing:border-box; padding:0px; margin:0px; text-align:right;">
                        <a :href="ado_infobutton_link" target="_blank" class="frmegyeniszamla_infobutton" style="color:var(--themecolor3) !important;">
                            <i class="fal fa-info-circle"></i>
                        </a>
                    </div>

                    <span class="frmegyeniszamla_itemlabel">Befizetései után járó adójóváírás</span>
                    <br><span class="frmegyeniszamla_itemdata">{{AktAdojovairas}}</span>
                    <div style="width:100%; box-sizing:border-box; text-align:center; padding:20px 0px;" v-show="TovabbiAdojovairasBefiz!=''">
                        <span style="color:var(--colorMain4); font-weight:bold;">{{TovabbiAdojovairasBefiz}}</span> befizetésével még további
                        <br><span style="white-space:nowrap; font-weight:bold;">{{TovabbiAdojovairas}}</span> jóváírást érvényesíthet!
                        <a :href="ado_infobutton_link" target="_blank" style="color:var(--themecolor4) !important;">
                            <i class="fal fa-info-circle"></i>
                        </a>                        
                    </div>
                    <a class="cms_linkbutton cms_linkbutton_BLUE_FULL" style="margin-top:10px;" href="befizetes">Befizetek</a>
                </div>
            </div>
        </div>

        <grccms_accordion ref="acc_lasttx" cms_stylename="accordion_default" cms_opened="false" cms_lazyload="true" v-on:onlazyload="OnLazyLoad_LastTX" style="margin-top:15px;">
            <template slot="acc_header">
                <i class="fal fa-exchange-alt" style="font-size: 28px; vertical-align: middle; display: inline-block; width: 50px;"></i><b>Legutóbbi tranzakcióim</b>
                <div class="frmegyeniszamla_legutobbi_header">
                    <div class="frmegyeniszamla_legutobbi_header_item" v-show="STAT[0].KartyaTX!=''">
                        <span class="frmegyeniszamla_legutobbi_header_item_label">Kártyás fizetés:</span>
                        <span class="frmegyeniszamla_legutobbi_header_item_value">{{STAT[0].KartyaTX}}</span>
                    </div>
                    <div class="frmegyeniszamla_legutobbi_header_item" v-show="STAT[0].Jovairas!=''">
                        <span class="frmegyeniszamla_legutobbi_header_item_label">Jóváírás:</span>
                        <span class="frmegyeniszamla_legutobbi_header_item_value">{{STAT[0].Jovairas}}</span>
                    </div>
                    <div class="frmegyeniszamla_legutobbi_header_item" v-show="STAT[0].KPSzamla!=''">
                        <span class="frmegyeniszamla_legutobbi_header_item_label">Készpénzes számla:</span>
                        <span class="frmegyeniszamla_legutobbi_header_item_value">{{STAT[0].KPSzamla}}</span>
                    </div>
                </div>
            </template>
            <template slot="acc_content">

                <div class="frmegyeniszamla_legutobbi_infotext">
                    <i class="fal fa-info-circle" style="margin-right:8px;"></i>A listák a fedezeti alapra vonatkozó összegeket tartalmazzák!
                </div>

                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    <div class="frmegyeniszamla_legutobbi_title" v-show="KARTYATX.length>0">Kártyás fizetések:</div>
                    <div class="frmegyeniszamla_legutobbi_itemcont" v-for="(txitem,txindex) in KARTYATX" :key="txindex">
                        <div class="frmegyeniszamla_legutobbi_col1">{{txitem.Datum}}</div>
                        <div class="frmegyeniszamla_legutobbi_col4">{{txitem.Osszeg}}</div>
                        <div class="frmegyeniszamla_legutobbi_col2" v-html="txitem.Szoveg"></div>
                        <div class="frmegyeniszamla_legutobbi_col3">{{txitem.Osszeg}}</div>
                    </div>
                    <div style="width:100%; height:20px;" v-show="KARTYATX.length>0">&nbsp;</div>
                </div>

                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    <div class="frmegyeniszamla_legutobbi_title" v-show="JOVAIRASOK.length>0">Jóváírások könyvelése:</div>
                    <div class="frmegyeniszamla_legutobbi_itemcont" v-for="(jovaitem,jovaindex) in JOVAIRASOK" :key="jovaindex">
                        <div class="frmegyeniszamla_legutobbi_col1">{{jovaitem.Datum}}</div>
                        <div class="frmegyeniszamla_legutobbi_col4">{{jovaitem.Osszeg}}</div>
                        <div class="frmegyeniszamla_legutobbi_col2" v-html="jovaitem.Szoveg"></div>
                        <div class="frmegyeniszamla_legutobbi_col3">{{jovaitem.Osszeg}}</div>
                    </div>
                    <div style="width:100%; height:20px;" v-show="JOVAIRASOK.length>0">&nbsp;</div>
                </div>

                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    <div class="frmegyeniszamla_legutobbi_title" v-show="KPSZAMLAK.length>0">Készpénzes számlák kifizetése:</div>
                    <div class="frmegyeniszamla_legutobbi_itemcont" v-for="(kpitem,kpindex) in KPSZAMLAK" :key="kpindex">
                        <div class="frmegyeniszamla_legutobbi_col1">{{kpitem.Datum}}</div>
                        <div class="frmegyeniszamla_legutobbi_col4">{{kpitem.Osszeg}}</div>
                        <div class="frmegyeniszamla_legutobbi_col2" v-html="kpitem.Szoveg"></div>
                        <div class="frmegyeniszamla_legutobbi_col3">{{kpitem.Osszeg}}</div>
                    </div>
                    <div style="width:100%; height:20px;" v-show="KPSZAMLAK.length>0">&nbsp;</div>
                </div>

            </template>
        </grccms_accordion>


        <grccms_accordion cms_stylename="accordion_lavenderblush" cms_opened="false" style="margin-top:15px;" v-show="JOGSZLENEJ.length>0">
            <template slot="acc_header">
                <div style="width:100%; color:var(--colorMain8);">
                    <i class="fal fa-exclamation-triangle" style="font-size: 32px; vertical-align: middle; display: inline-block; width: 50px;"></i>
                    <b>Jogosulatlan és életmódjavító igénybevételek</b>
                </div>
            </template>
            <template slot="acc_content">
                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    
                    <div class="frmegyeniszamla_legutobbi_itemcont" v-for="(jszitem,jszindex) in JOGSZLENEJ" :key="jszindex">
                        <div class="frmegyeniszamla_legutobbi_col2" v-html="jszitem.Szoveg"></div>
                        <div class="frmegyeniszamla_legutobbi_col4" style="width:100%; text-align:center; font-weight:bold;">{{jszitem.Adokoteles}}</div>
                        <div class="frmegyeniszamla_legutobbi_col3">&nbsp;</div>                
                        <div class="frmegyeniszamla_legutobbi_col3">{{jszitem.Adokoteles}}</div>
                    </div>

                    <div style="width:100%; box-sizing: border-box; text-align: center;">
                        <a href="https://www.vitaminep.hu/main/elszamolasi-rend" target="_blank" class="cms_linkbutton cms_linkbutton_BLUE_FULL"
                        >További információk >></a>

                        <div style="width:100%; box-sizing:border-box; display:block; margin:10px 0px; text-align:center;" v-show="BefizOsszeg_Jogosulatlan>0">
                            <a :href="Jogosulatlan_BefizLink" class="cms_linkbutton cms_linkbutton_RED_FULL"
                            style="text-decoration: none;"
                            >Jogosulatlan igénybevételek visszafizetése >></a>
                        </div>

                        <div style="width:100%; box-sizing:border-box; display:block; margin:10px 0px; text-align:center;" v-show="BefizOsszeg_EJ>0">
                            <a :href="EJ_BefizLink" class="cms_linkbutton cms_linkbutton_GREEN_FULL"
                            style="background-color: orange !important; border-color: orange !important; text-decoration: none;"
                            >Életmódjavító igénybevételek visszafizetése >></a>
                        </div>

                    </div>

                    <div style="width:100%; height:20px;" v-show="JOGSZLENEJ.length>0">&nbsp;</div>
                </div>
            </template>
        </grccms_accordion>



        <grccms_accordion cms_stylename="accordion_lavenderblush" cms_opened="false" style="margin-top:15px;" v-show="NEMBEFOGADHATO.length>0">
            <template slot="acc_header">
                <div style="width:100%; color:var(--colorMain8);">
                    <i class="fal fa-exclamation-triangle" style="font-size: 32px; vertical-align: middle; display: inline-block; width: 50px;"></i>
                    <b>Nem befogadható vagy fedezet nélküli számlák</b>
                </div>
            </template>
            <template slot="acc_content">
                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    
                    <div class="frmegyeniszamla_legutobbi_itemcont" v-for="(nbitem,nbindex) in NEMBEFOGADHATO" :key="nbindex">
                        <div class="frmegyeniszamla_legutobbi_col2" v-html="nbitem.Szoveg"></div>
                        <div class="frmegyeniszamla_legutobbi_col4" style="width:100%; text-align:center; font-weight:bold;">{{nbitem.Osszeg}}</div>
                        <div class="frmegyeniszamla_legutobbi_col3">&nbsp;</div>                
                        <div class="frmegyeniszamla_legutobbi_col3">{{nbitem.Osszeg}}</div>
                    </div>

                    <div style="width:100%; box-sizing: border-box; text-align: center;">
                        <a href="https://www.vitaminep.hu/main/elszamolasi-rend" target="_blank" class="cms_linkbutton cms_linkbutton_BLUE_FULL"
                        >További információk >></a>
                    </div>

                    <div style="width:100%; box-sizing:border-box; display:block; margin:10px 0px; text-align:center;">
                        <a href="https://portal.vitaminep.hu/main/befizetes" class="cms_linkbutton cms_linkbutton_GREEN_FULL"
                        style="text-decoration: none;"
                        >Befizetek az egyéni számlámra >></a>
                    </div>


                    <div style="width:100%; height:20px;" v-show="NEMBEFOGADHATO.length>0">&nbsp;</div>
                </div>
            </template>
        </grccms_accordion>




        <grccms_accordion ref="acc_szlastat" cms_stylename="accordion_default" cms_opened="false" cms_lazyload="true" v-on:onlazyload="OnLazyLoad_SZLASTAT" style="margin-top:15px;">
            <template slot="acc_header">
                <i class="fal fa-chart-bar" style="font-size: 32px; vertical-align: middle; display: inline-block; width: 50px;"></i><b>Számla statisztika</b>
                <div class="frmegyeniszamla_szlastat_header">
                    <div class="frmegyeniszamla_szlastat_header_item" v-show="SZLASTAT[0].Iden!=''">
                        <span class="frmegyeniszamla_szlastat_header_item_label">Idei évben:</span>
                        <span class="frmegyeniszamla_szlastat_header_item_value" v-html="SZLASTAT[0].Iden"></span>
                    </div>
                    <div class="frmegyeniszamla_szlastat_header_item" v-show="SZLASTAT[0].Tavaly!=''">
                        <span class="frmegyeniszamla_szlastat_header_item_label">Tavalyi évben:</span>
                        <span class="frmegyeniszamla_szlastat_header_item_value" v-html="SZLASTAT[0].Tavaly"></span>
                    </div>

                </div>
            </template>
            <template slot="acc_content">

                <div class="frmegyeniszamla_szlastat_infotext">
                    <i class="fal fa-info-circle" style="margin-right:8px;"></i>A lista a jogosulatlan szolgáltatás igénybevételeket nem tartalmazza!
                </div>

                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    <div class="frmegyeniszamla_szlastat_title" v-show="SZLASTAT_IDEN.length>0">Idei évben:</div>
                    <div class="frmegyeniszamla_szlastat_itemcont" v-for="(szlaiden_item,szlaiden_index) in SZLASTAT_IDEN" :key="szlaiden_index">
                        <div class="frmegyeniszamla_szlastat_col1" v-html="szlaiden_item.Szoveg"></div>
                        <div class="frmegyeniszamla_szlastat_col2" v-html="szlaiden_item.Osszeg"></div>
                    </div>
                    <div style="width:100%; height:20px;" v-show="SZLASTAT_IDEN.length>0">&nbsp;</div>
                </div>

                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    <div class="frmegyeniszamla_szlastat_title" v-show="SZLASTAT_TAVALY.length>0">Tavalyi évben:</div>
                    <div class="frmegyeniszamla_szlastat_itemcont" v-for="(szlatavaly_item,szlatavaly_index) in SZLASTAT_TAVALY" :key="szlatavaly_index">
                        <div class="frmegyeniszamla_szlastat_col1" v-html="szlatavaly_item.Szoveg"></div>
                        <div class="frmegyeniszamla_szlastat_col2" v-html="szlatavaly_item.Osszeg"></div>
                    </div>
                </div>

            </template>
        </grccms_accordion>


        <grccms_accordion cms_stylename="accordion_default" cms_opened="false" style="margin-top:15px;">
            <template slot="acc_header">
                <div style="width:100%;">
                    <i class="fal fa-file-pdf" style="font-size: 32px; vertical-align: bottom; display: inline-block; width: 50px;"></i>
                    <b>Részletes egyéni számla megtekintése</b>
                </div>
            </template>
            <template slot="acc_content">
                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">

                    <div style="width:100%; box-sizing:border-box; padding:0px; margin:0px; text-align:left; margin-bottom:10px;">
                        <a href="reszletes-egyeni-szamla-ismertetese" class="frmegyeniszamla_infobutton" style="font-size:18px; line-height:24px; text-align:left; text-decoration:underline;">
                            <i class="fal fa-info-circle" style="margin-right:8px;"></i>Az egyéni számla ismertetése
                        </a>
                    </div>


                    <div class="frmegyeniszamla_reszletes_item" v-for="(evitem, evindex) in EGYSZLAEVEK" :key="evindex"
                        @click="DisplayEgylszlaReport(evitem.EvParam)">
                        <i class="fal fa-file-pdf" style="margin-right:8px; font-size: 26px; vertical-align: text-bottom; display:none;"></i>{{evitem.Ev}}
                    </div>

                </div>
            </template>
        </grccms_accordion>



    </div>
</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';
import { clearTimeout } from 'timers';

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import grccms_accordion from '../GrcComponents/grccms_accordion.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'

export default {
  name: 'frmegyeniszamla',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      grccms_accordion,
      GrcDocDisplayer
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmEgyeniSzamla_",

          InitDone:false,  

          Egyenleg:"",
          SimpleNincsKonyvelve:"",
          Egyenleg180:"",
          AktAdojovairas:"",
          TovabbiAdojovairas:"",
          TovabbiAdojovairasBefiz:"",
          egyenleg_infobutton_link:"",
          ado_infobutton_link:"",

          KARTYATX:[],
          JOVAIRASOK:[],
          KPSZAMLAK:[],
          JOGSZLENEJ:[],
          NEMBEFOGADHATO:[],

          SZLASTAT:[{Iden:"", Tavaly:""}],
          SZLASTAT_IDEN:[],
          SZLASTAT_TAVALY:[],

          STAT:[ {KartyaTX:"", Jovairas: "", KPSzamla:"" }],

          EGYSZLAEVEK:[],

          BefizOsszeg_Jogosulatlan:0,
          Jogosulatlan_BefizLink:"https://portal.vitaminep.hu/main/befizetes?tipusid=3",

          BefizOsszeg_EJ:0,
          EJ_BefizLink:"https://portal.vitaminep.hu/main/befizetes?tipusid=2"


      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmEgyeniSzamla", pCompName);
    },

    SetLang()
    {
        this.egyenleg_infobutton_link = this.GetTextBookItem("egyenleg_infobutton_link");
        this.ado_infobutton_link = this.GetTextBookItem("ado_infobutton_link");

        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },


    OpenSZLASTAT()
    {
        this.$refs.acc_szlastat.SetLazyLoad(false);
        this.$refs.acc_szlastat.SetIsOpened(true);
        this.$refs.GRCDB.HideLoading();
    },

    async OnLazyLoad_SZLASTAT()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "SZLASTAT", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }


        this.SZLASTAT = Q.SZLASTAT;
        this.SZLASTAT_IDEN = Q.SZLASTAT_IDEN;
        this.SZLASTAT_TAVALY = Q.SZLASTAT_TAVALY;


        setTimeout(this.OpenSZLASTAT ,1000);
        

    },



    OpenLastTX()
    {
        this.$refs.acc_lasttx.SetLazyLoad(false);
        this.$refs.acc_lasttx.SetIsOpened(true);
        this.$refs.GRCDB.HideLoading();
    },

    async OnLazyLoad_LastTX()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "LastTX", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }


        this.KARTYATX = Q.KARTYATX;
        this.JOVAIRASOK = Q.JOVAIRASOK;
        this.KPSZAMLAK = Q.KPSZAMLAK;

        this.STAT = Q.STAT;


        setTimeout(this.OpenLastTX ,1000);
        

    },

    async DisplayEgylszlaReport(pEv)
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]",
            iEv:pEv
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "GetReport", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var docb64 = Q.RESULT[0].DocData;
        var docfn = Q.RESULT[0].FajlNev;
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi


        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }

    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.Egyenleg = Q.RESULT[0].Egyenleg;
        this.SimpleNincsKonyvelve = Q.RESULT[0].SimpleNincsKonyvelve;
        this.Egyenleg180 = Q.RESULT[0].Egyenleg180;
        this.AktAdojovairas = Q.RESULT[0].AktAdojovairas;
        this.TovabbiAdojovairas = Q.RESULT[0].TovabbiAdojovairas;
        this.TovabbiAdojovairasBefiz = Q.RESULT[0].TovabbiAdojovairasBefiz;


        this.STAT = Q.STAT;
        this.JOGSZLENEJ = Q.JOGSZLENEJ;
        this.EGYSZLAEVEK = Q.EGYSZLAEVEK;
        this.NEMBEFOGADHATO = Q.NEMBEFOGADHATO;

        this.SZLASTAT = Q.SZLASTAT;

        this.BefizOsszeg_Jogosulatlan = Q.MISC[0].BefizOsszeg_Jogosulatlan;
        if (this.BefizOsszeg_Jogosulatlan > 0)
        {
            this.Jogosulatlan_BefizLink = this.Jogosulatlan_BefizLink + "&osszeg="+this.BefizOsszeg_Jogosulatlan;
        }

        this.BefizOsszeg_EJ = Q.MISC[0].BefizOsszeg_EJ;
        if (this.BefizOsszeg_EJ > 0)
        {
            this.EJ_BefizLink = this.EJ_BefizLink + "&osszeg="+this.BefizOsszeg_EJ;
        }

        this.InitDone = true;

      },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


